import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useCurrency } from '../../../../hooks/useCurrency';

const SystemLiveTrades = () => {
  const { convertFromUSD, currencySymbol, formatAmountWithoutCurrency } = useCurrency();

  const trades = [
    { id: 1, seller: 'Alice', buyer: 'Bob', item: 'Dragon Lore', amount: 1450.00 },
    { id: 2, seller: 'Charlie', buyer: 'Dave', item: 'Howl', amount: 2100.00 },
  ];

  return (
      <div className="flex-1 bg-neutral-900/40 backdrop-blur-md border border-neutral-800 rounded-lg p-5">
        <div className="flex items-center gap-2 mb-4">
          <ShoppingBag className="w-4 h-4 text-purple-400" />
          <h3 className="text-xs font-black uppercase tracking-widest text-white">Live Trades</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
            <tr className="border-b border-neutral-800 text-[10px] text-neutral-500 uppercase tracking-tighter">
              <th className="pb-2">Seller/Buyer</th>
              <th className="pb-2">Item</th>
              <th className="pb-2 text-right">Price</th>
            </tr>
            </thead>
            <tbody className="divide-y divide-neutral-800/50">
            {trades.map((trade) => (
                <tr key={trade.id} className="text-[11px] group hover:bg-white/[0.02]">
                  <td className="py-2">
                    <div className="flex flex-col">
                      <span className="text-neutral-300 font-bold">{trade.seller}</span>
                      <span className="text-neutral-500 text-[9px] uppercase">to {trade.buyer}</span>
                    </div>
                  </td>
                  <td className="py-2 text-neutral-400 font-medium italic">{trade.item}</td>
                  <td className="py-2 text-right font-mono font-black text-blue-400">
                    {currencySymbol}{formatAmountWithoutCurrency(convertFromUSD(trade.amount))}
                  </td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default SystemLiveTrades;